// Loader: jangkar naik-turun + lapisan air bergerak parallax
const WAVE_PATH = 'M0 12 Q 27.5 2 55 12 T 110 12 T 165 12 T 220 12'

function Wave({ color, top, opacity, duration }: { color: string; top: number; opacity: number; duration: string }) {
  return (
    <div className="anchor-loader__wave" style={{ top, opacity, animationDuration: duration }}>
      <svg viewBox="0 0 220 22" preserveAspectRatio="none">
        <path d={WAVE_PATH} fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" />
      </svg>
      <svg viewBox="0 0 220 22" preserveAspectRatio="none">
        <path d={WAVE_PATH} fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" />
      </svg>
    </div>
  )
}

const BUBBLES = [
  { left: 70, size: 6, delay: '0s', dur: '2.6s' },
  { left: 120, size: 9, delay: '0.8s', dur: '3.2s' },
  { left: 150, size: 5, delay: '1.4s', dur: '2.4s' },
]

export function AnchorLoader({ label = 'Memuat…' }: { label?: string }) {
  return (
    <div className="anchor-loader" aria-busy="true" aria-label={label}>
      <div className="anchor-loader__scene">
        {/* Air — 3 lapisan, kecepatan beda = parallax */}
        <Wave color="#9CC9C6" top={86} opacity={0.45} duration="5.5s" />
        <Wave color="#5BAFAC" top={98} opacity={0.6} duration="3.8s" />
        <Wave color="#2B8A8A" top={110} opacity={0.85} duration="2.6s" />

        {/* Gelembung naik */}
        {BUBBLES.map((b, i) => (
          <span key={i} className="anchor-loader__bubble"
            style={{ left: b.left, width: b.size, height: b.size, animationDelay: b.delay, animationDuration: b.dur }} />
        ))}

        {/* Jangkar bobbing */}
        <div className="anchor-loader__anchor">
          <svg viewBox="0 0 140 190" fill="none" className="w-full h-auto">
            <g stroke="currentColor" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="70" cy="20" r="11" />
              <line x1="70" y1="31" x2="70" y2="151" />
              <line x1="44" y1="52" x2="96" y2="52" />
              <path d="M28 120 C 34 158 54 170 70 151 C 86 170 106 158 112 120" />
            </g>
            <path d="M28 120 L 14 116 L 24 132 Z" fill="currentColor" />
            <path d="M112 120 L 126 116 L 116 132 Z" fill="currentColor" />
          </svg>
        </div>
      </div>

      <p className="text-[12px] font-body text-[#8A8A85] tracking-wide">{label}</p>
    </div>
  )
}
